import { Card } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { LoadingAnimation } from '../ui/loadingAnimation/LoadingAnimation';

export const ApplicationLoadingCard = ({
    className,
    ...props
}: React.ComponentPropsWithoutRef<typeof Card>) => {
    return (
        <Card className={className} {...props}>
            <LoadingAnimation />
            <h2>
                <FormattedMessage
                    id="_.loading_application.header"
                    defaultMessage="We're completing your application"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="_.loading_application.description"
                    defaultMessage="This may take up to 60 seconds"
                />
            </p>
        </Card>
    );
};
